export const SET_COMMON_COMPANY_ID = 'SET_COMMON_COMPANY_ID';
export const REMOVE_COMMON_COMPANY_ID = 'REMOVE_COMMON_COMPANY_ID';

export const SET_COMMON_BRANCH_ID = 'SET_COMMON_BRANCH_ID';
export const REMOVE_COMMON_BRANCH_ID = 'REMOVE_COMMON_BRANCH_ID';
export const SET_COMMON_COMPANIES = 'SET_COMMON_COMPANIES';
export const SET_COMMON_BRANCHES = 'SET_COMMON_BRANCHES';
export const NEW_ALERTS_COUNT = 'NEW_ALERTS_COUNT';
